<li [dragula]="'DRAGGABLE'" [class]="{ show: label, hide: !label, clickedLi: isActive(), disabled: disabled}">
    <hex-label-item *ngIf="addButton" [link]="link" [label]="label" (click)="toggleClick()"
        [class]="label ? 'show' : 'hide'">
    </hex-label-item>
    <div *ngIf="!addButton" class="wrapper" [class.submenu-parent]="hasChildren && !link" (click)="toggleClick()" [attr.title]="disabled ? disabledReason : null"
        [attr.role]="hasChildren && !link ? 'button' : null" [attr.tabindex]="hasChildren && !link ? 0 : null"
        [attr.aria-expanded]="hasChildren && !link ? isExpanded() : null" (keydown.enter)="toggleClick()"
        (keydown.space)="toggleClick(); $event.preventDefault()">
        <div class="container" draggable="true">
            <div [class]="{ activeBg: isActive() }"></div>
            <p>{{ label }}</p>
            <mat-icon *ngIf="hasChildren && !link" class="submenu-indicator" [class.expanded]="isExpanded()">
                expand_more
            </mat-icon>
        </div>
        <red-cross-button *ngIf="type === 'Usecase'" class="red-cross" (press)="deleteUsecase()"></red-cross-button>
    </div>
    <ul *ngIf="hasChildren && isExpanded()" class="submenu-children">
        <app-sidemenu-button *ngFor="let child of children" [label]="child.label" [link]="child.link"
            [hasNoImage]="true" [entityId]="child.entityId" [ptgId]="child.ptgId" [addButton]="child.addButton"
            [type]="child.type" [rating]="child.rating" [composerItem]="child.composerItem" [children]="child.children"
            [hasChildren]="child.hasChildren" [clicked]="child.clicked" [disabled]="child.disabled" [disabledReason]="child.disabledReason" [isCertification]="isCertification">
        </app-sidemenu-button>
    </ul>
</li>
